import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "s20 widget bg-gradient-dark text-white px-7 py-7 rounded-40" }
const _hoisted_3 = { class: "s4_mobile px-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "profile-avatar-placeholder rounded-100 overflow-hidden"
}
const _hoisted_6 = { class: "s16_mobile px-5 mt-5" }
const _hoisted_7 = { class: "secondary-font mb-3" }
const _hoisted_8 = { class: "secondary-font font-normal mb-3" }
const _hoisted_9 = { class: "grid2" }
const _hoisted_10 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_11 = { class: "s14" }
const _hoisted_12 = { class: "secondary-font font-black text-primary-color" }
const _hoisted_13 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.6)"}
}
const _hoisted_14 = { class: "s6" }
const _hoisted_15 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_16 = { class: "s14" }
const _hoisted_17 = { class: "secondary-font font-semibold text-grey-100 mb-1" }
const _hoisted_18 = { class: "secondary-font font-black text-primary-color" }
const _hoisted_19 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.6)"}
}
const _hoisted_20 = { class: "s6" }
const _hoisted_21 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_22 = { class: "s14" }
const _hoisted_23 = { class: "secondary-font font-black text-primary-color" }
const _hoisted_24 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.6)"}
}
const _hoisted_25 = { class: "s6" }
const _hoisted_26 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_27 = { class: "s14" }
const _hoisted_28 = { class: "secondary-font font-black text-primary-color" }
const _hoisted_29 = { class: "s20 px-5" }
const _hoisted_30 = { class: "s10 secondary-font mb-4" }
const _hoisted_31 = { class: "s10 secondary-font mb-4" }
const _hoisted_32 = { class: "s10 secondary-font mb-4" }
const _hoisted_33 = { class: "s10 secondary-font mb-4" }
const _hoisted_34 = { class: "s10 secondary-font mb-4" }
const _hoisted_35 = { class: "s10 secondary-font mb-4" }
const _hoisted_36 = { class: "s10 secondary-font mb-4" }
const _hoisted_37 = { class: "s10 secondary-font mb-4" }
const _hoisted_38 = { class: "s10 secondary-font mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-4" }, " Souscription ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.profil?.photo || _ctx.profil?.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: (_ctx.profil!.photo || _ctx.profil!.avatar)!,
              width: "100%",
              class: "rounded-100 overflow-hidden item active"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-profil.svg",
                class: "icon-white size-xl",
                alt: "Avatar"
              }, null, -1)
            ]))]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "secondary-font mb-3" }, " Détail de ma souscription ", -1)),
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.profil?.prenom) + " " + _toDisplayString(_ctx.profil?.nom), 1),
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.profil?.collectivite_nom || '-') + " - " + _toDisplayString(_ctx.profil?.telephone || ''), 1)
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "s6" }, [
            _createElementVNode("h1", { class: "secondary-font font-normal text-grey-100" }, "Ce"),
            _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-100 mb-1" }, "Mon Revolving", -1)),
            _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.formatAmount(_ctx.monRevolving)) + " F", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.souscription?.duree_mois || 12), 1),
            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois", -1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, "Revolving sur " + _toDisplayString(_ctx.souscription?.duree_mois || 12) + " mois", 1),
            _createElementVNode("h1", _hoisted_18, _toDisplayString(_ctx.formatAmount(Math.abs(_ctx.souscription?.pouvoir_achat_an || 0))) + " F", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.profil?.prelevement_pourcent || 0) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-100 mb-1" }, "Prélèvement sur salaire", -1)),
            _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.formatAmount(_ctx.profil?.prelevement_montant || 0)) + " F", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.quotiteDisponiblePourcent) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-100 mb-1" }, "Quotité encore disponible", -1)),
            _createElementVNode("h1", _hoisted_28, _toDisplayString(_ctx.formatAmount(_ctx.quotiteDisponibleMontant)) + " F", 1)
          ])
        ])
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      _createElementVNode("div", _hoisted_29, [
        _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Date de souscription", -1)),
        _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.formatDateFrench(_ctx.souscription?.date_debut)), 1),
        _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Date de fin de souscription", -1)),
        _createElementVNode("h5", _hoisted_31, _toDisplayString(_ctx.formatDateFrench(_ctx.souscription?.date_fin)), 1),
        _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "hr-white s20 mb-5" }, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Salaire", -1)),
        _createElementVNode("h5", _hoisted_32, _toDisplayString(_ctx.formatAmount(_ctx.profil?.salaire || 0)) + " F", 1),
        _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Prélèvement sur salaire", -1)),
        _createElementVNode("h5", _hoisted_33, _toDisplayString(_ctx.profil?.prelevement_pourcent || 0) + "%", 1),
        _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Utilisation totale", -1)),
        _createElementVNode("h5", _hoisted_34, _toDisplayString(_ctx.formatAmount(_ctx.profil?.prelevement_montant || 0)) + " F", 1),
        _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Salaire Net après Utilisation", -1)),
        _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.formatAmount((_ctx.profil?.salaire || 0) - (_ctx.profil?.prelevement_montant || 0))) + " F", 1),
        _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "hr-white s20 mb-5" }, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Pouvoir d'achat", -1)),
        _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.formatAmount(Math.abs(_ctx.souscription?.pouvoir_achat || 0))) + " F", 1),
        _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Quotité cessible max", -1)),
        _createElementVNode("h5", _hoisted_37, _toDisplayString(_ctx.profil?.quotite_cessible_pourcent || 0) + "% - " + _toDisplayString(_ctx.formatAmount(_ctx.profil?.quotite_cessible_montant || 0)) + " F", 1),
        _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "s10 secondary-font mb-1" }, "Quotité cessible encore disponible", -1)),
        _createElementVNode("h5", _hoisted_38, _toDisplayString(_ctx.quotiteDisponiblePourcent) + "% - " + _toDisplayString(_ctx.formatAmount(_ctx.quotiteDisponibleMontant)) + " F", 1)
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}